import { defineComponent, ref, useTemplateRef, watch, resolveDirective, createBlock, openBlock, mergeProps, withKeys, withCtx, withDirectives, createCommentVNode, createElementBlock, normalizeClass, createVNode } from "vue";
import { S as SIZES } from "./chunks/p-btn.types.js";
import { _ as _sfc_main$2 } from "./chunks/p-icon.js";
import { _ as _sfc_main$1 } from "./chunks/p-input.js";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PInputSearch",
    inheritAttrs: false
  },
  __name: "p-input-search",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return SIZES.includes(value);
      }
    },
    showEnterIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "enter"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const searchIconClasses = {
      sm: "text-xs top-2.5 left-2",
      md: "text-base top-3 left-3",
      lg: "text-lg top-4 left-5"
    };
    const clearIconClasses = {
      sm: "text-base top-1.5 right-2",
      md: "text-xl top-2 right-2.5",
      lg: "text-3xl top-[5px] right-2.5"
    };
    const enterIconClasses = {
      sm: "bg-[length:1rem_1rem] w-[1rem] h-[1rem] right-7 top-2",
      md: "bg-[length:1.5rem_1.5rem] w-[1.5rem] h-[1.5rem] right-9 top-2",
      lg: "bg-[length:2rem_2rem] w-[2rem] h-[2rem] right-[46px] top-2"
    };
    const showEnterIconOnFocus = ref(false);
    const input = useTemplateRef("pInput");
    const query = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (nV) => {
        query.value = nV;
      }
    );
    watch(query, (nV) => {
      emit("update:modelValue", nV);
    });
    const clearSearch = () => {
      query.value = "";
      requestAnimationFrame(() => {
        var _a;
        (_a = input.value) == null ? void 0 : _a.$el.querySelector("input").focus();
      });
    };
    const keydownEnter = () => {
      emit("enter", query.value);
    };
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createBlock(_sfc_main$1, mergeProps({ ref: "pInput" }, _ctx.$attrs, {
        modelValue: query.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => query.value = $event),
        size: __props.size,
        role: "searchbox",
        rounded: "",
        onFocus: _cache[1] || (_cache[1] = ($event) => showEnterIconOnFocus.value = true),
        onFocusout: _cache[2] || (_cache[2] = ($event) => showEnterIconOnFocus.value = false),
        onKeydown: withKeys(keydownEnter, ["enter"])
      }), {
        prefix: withCtx(() => [
          createVNode(_sfc_main$2, {
            icon: "search",
            class: normalizeClass(["absolute text-p-gray-40", searchIconClasses[__props.size]])
          }, null, 8, ["class"])
        ]),
        suffix: withCtx(() => [
          query.value && __props.showEnterIcon && showEnterIconOnFocus.value ? withDirectives((openBlock(), createElementBlock("i", {
            key: 0,
            class: normalizeClass(["enter absolute bg-no-repeat outline-none", enterIconClasses[__props.size]])
          }, null, 2)), [
            [
              _directive_tooltip,
              { content: "Press enter to search", delay: { show: 100, hide: 0 } },
              void 0,
              { bottom: true }
            ]
          ]) : createCommentVNode("", true),
          query.value ? (openBlock(), createElementBlock("button", {
            key: 1,
            role: "button",
            "aria-label": "Clear search input",
            class: normalizeClass(["absolute cursor-pointer", clearIconClasses[__props.size]]),
            onClick: clearSearch
          }, [
            createVNode(_sfc_main$2, {
              icon: "cancel-circle",
              class: "text-p-gray-40 hover:text-p-gray-50"
            })
          ], 2)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["modelValue", "size"]);
    };
  }
});
const PInputSearch = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0e51ff56"]]);
export {
  PInputSearch as default
};
